// List of common crops grown in Kenya
export const crops = [
  'Maize',
  'Beans',
  'Potatoes',
  'Sweet Potatoes',
  'Cassava',
  'Rice',
  'Wheat',
  'Sorghum',
  'Millet',
  'Bananas',
  'Coffee',
  'Tea',
  'Sugarcane',
  'Cotton',
  'Pyrethrum',
  'Tomatoes',
  'Cabbages',
  'Kales (Sukuma Wiki)',
  'Onions',
  'Carrots',
  'Spinach',
  'Avocados',
  'Mangoes',
  'Oranges',
  'Passion Fruits',
  'Pineapples',
  'Watermelons',
  'Macadamia Nuts',
  'Cashew Nuts',
  'Groundnuts',
  'Sisal',
  'Tobacco',
  'French Beans',
  'Snow Peas',
  'Green Grams',
  'Black Beans',
  'Cowpeas',
  'Pigeon Peas',
  'Sunflower',
  'Soya Beans'
];